<template>
  <v-card>
    <v-tabs v-model="tab" background-color="primary" grow dark>
      <v-tabs-slider></v-tabs-slider>
      <v-tab to="/production_order/order">{{ $t('message.layout.order') }}</v-tab>
      <v-tab to="/production_order/in_production">{{ $t('message.productionOrder.inProduction') }}</v-tab>
      <v-tab to="/production_order/by_product">{{ $t('message.productionOrder.byProduct') }}</v-tab>
      <v-tab to="/production_order/archived">{{ $t('message.productionOrder.archived') }}</v-tab>
    </v-tabs>
    <div v-show="isShowCode">
      <svg id="product_number"></svg>
      <svg id="order_number"></svg>
    </div>
   <router-view></router-view>
  </v-card>
</template>
<script>
import productionOrderMixin from './productionOrderMixin'
export default {
  mixins: [productionOrderMixin],
  data () {
    return {
      tab: null,
      reportData: {},
      isShowCode: false,
      moduleName: ''
    }
  },
  watch: {
    '$route.name' (val) {
      if (!val) this.$router.go(-1)
    }
  },
  mounted () {
    this.$root.$on('getDataForPDF', obj => {
      this.reportData = obj.data
      this.moduleName = obj.moduleName
      this.downloadReport()
    })
  },
  methods: {
    getStatusTranslated (status) {
      if (!status) return ''
      const statusObj = this.listOfStatus.find(x => x.val === status)
      if (statusObj) return statusObj.text
      else return ''
    },
    getPriorityTranslated (priority) {
      if (!priority) return ''
      const priorityObj = this.listOfPriority.find(x => x.val === priority)
      if (priorityObj) return priorityObj.text
      else return ''
    },
    getBarCodeForProduct (productNumber) {
      var JsBarcode = require('jsbarcode')
      const code = JsBarcode('#product_number', productNumber, { height: 55, textAlign: 'left', fontSize: 15 })
      return code._renderProperties[0].element.outerHTML
    },
    getBarCodeForOrder (orderNumber) {
      var JsBarcode = require('jsbarcode')
      const code = JsBarcode('#order_number', orderNumber, { height: 55, textAlign: 'left', fontSize: 15 })
      return code._renderProperties[0].element.outerHTML
    },
    generateReportForOrder () {
      // Tools
      let tools = ''
      for (let i = 0; i < this.reportData.tools.length; i++) {
        if (this.reportData.tools[i].active) {
          tools += `<tr>
            <td>${this.reportData.tools[i].name}</td>
            <td>${this.reportData.tools[i].rack_name}</td>
            <td>${this.reportData.tools[i].shelf_name}</td>
          </tr>`
        }
      }
      // Construct products based raw materials
      let constructContent = ''
      let productionOrders = this.reportData.productionorderreportperstates
      if (productionOrders && productionOrders.length > 0) {
        for (let i = 0; i < productionOrders.length; i++) {
          constructContent += this.productionOrderDetails(productionOrders[i], tools)
        }
      } else {
        productionOrders = { state: null, product: { product_number: null, product_name: '', rawmaterials: [] } }
        constructContent += this.productionOrderDetails(productionOrders, tools)
      }
      const content = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <title>Bootstrap Example</title>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css">
          <style>
            hr {
              margin-top: 2px;
              margin-bottom: 5px;
            }
            .no-border tbody tr td {
              border-top: 0px;
            }
            .mt-6 {
              margin-top: 6%;
            }
            .mt-3 {
              margin-top: 3%;
            }
            .container--per-product { page-break-after: always; }
            thead { display: table-header-group; }
            tfoot { display: table-row-group; }
            tr { page-break-inside: avoid; }
            tbody tr td { text-align: justify;word-break: break-word;}
          </style>
        </head>
        <body>${constructContent}</body>
        </html>`
      return btoa(unescape(encodeURIComponent(content)))
    },
    productionOrderDetails (productionOrder, tools) {
      return `<br><div class="container-fluid container--per-product">
            <img class="img-responsive" height="350" width="350" src="${process.env.VUE_APP_IMAGE_URL}/${process.env.VUE_APP_LOGO_NAME}" alt="rotostop">
            <hr>
            <div style="float: left;">ARBEIDSORDRE ${productionOrder.state}</div>
            <div style="float: right;">${this.$t('message.order.date')} :${this.convertToNormalFormat(this.reportData.order.order_date)}</div>
            <div class="clearfix"></div>
            <hr>
            <div class="container">
              <div class="row">
                <div class="col-xs-2">
                  <label>${this.$t('message.product.number')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.reportData.order.number}
                </div>
                <div class="col-xs-2">
                  <label>${this.$t('message.productionOrder.orderStatus')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.getStatusTranslated(this.reportData.order.status)}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-2">
                  <label>${this.$t('message.warehouse.productName')} : </label>
                </div>
                <div class="col-xs-4">
                  ${productionOrder.product.product_number || ''} - ${productionOrder.product.product_name || ''}
                </div>
                <div class="col-xs-2">
                  <label>${this.$t('message.productionOrder.productStatus')} : </label>
                </div>
                <div class="col-xs-4">
                 ${productionOrder.state}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-2">
                  <label>${this.$t('message.orders.orderDate')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.convertToNormalFormat(this.reportData.order.order_date)}
                </div>
                <div class="col-xs-2">
                  <label>${this.$t('message.order.startDate')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.convertToNormalFormat(this.reportData.order.start_date)}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-2">
                  <label>${this.$t('message.productionOrder.started')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.reportData.started_date ? this.convertToNormalFormat(this.reportData.started_date) : ''}
                </div>
                <div class="col-xs-2">
                  <label>${this.$t('message.order.endDate')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.convertToNormalFormat(this.reportData.order.end_date)}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-2">
                  <label>${this.$t('message.customer.priority')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.getPriorityTranslated(this.reportData.order.priority)}
                </div>
                <div class="col-xs-2">
                  <label>${this.$t('message.order.deliveryDate')} : </label>
                </div>
                <div class="col-xs-4">
                  ${this.convertToNormalFormat(this.reportData.order.delivery_date)}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-6">
                  ${productionOrder.product.product_number ? this.getBarCodeForProduct(productionOrder.product.product_number) : ''}
                </div>
                <div class="col-xs-6">
                  ${this.getBarCodeForOrder(this.reportData.order.number)}
                </div>
              </div>
            </div>
            <hr>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th>${this.$t('message.customer.name')}</th>
                  <th>${this.$t('message.product.unit')}</th>
                  <th>${this.$t('message.productionOrder.volume')}</th>
                  <th>${this.$t('message.productionOrder.produced')}</th>
                  <th>${this.$t('message.productionOrder.finished')}</th>
                  <th>${this.$t('message.productionOrder.rest')}</th>
                  <th>${this.$t('message.productionOrder.extradit')}</th>
                </tr>
                ${this.constructRawMaterial(productionOrder.rawmaterials)}
              </tbody>
            </table>
            <div class="row">
              <div class="col-xs-6">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th width="56%">${this.$t('message.customer.name')}</th>
                      <th width="22%">${this.$t('message.settings.rack_name')}</th>
                      <th width="22%">${this.$t('message.settings.shelf_name')}</th>
                    </tr>
                    ${tools}
                  </tbody>
                </table>
              </div>
              <div class="col-xs-6">
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-xs-6">
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.plan_measures')}:</label>
                  </div>
                  <div class="col-xs-8">
                    ${productionOrder.product.plan_measure_1 ? this.$formatter.replaceDotWithComma(productionOrder.product.plan_measure_1) : ''} -
                     ${productionOrder.product.plan_measure_2 ? this.$formatter.replaceDotWithComma(productionOrder.product.plan_measure_2) : ''} -
                     ${productionOrder.product.plan_measure_3 ? this.$formatter.replaceDotWithComma(productionOrder.product.plan_measure_3) : ''}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.forging_measures')}:</label>
                  </div>
                  <div class="col-xs-8">
                    ${productionOrder.product.forging_measure_1 ? this.$formatter.replaceDotWithComma(productionOrder.product.forging_measure_1) : ''} -
                     ${productionOrder.product.forging_measure_2 ? this.$formatter.replaceDotWithComma(productionOrder.product.forging_measure_2) : ''} -
                     ${productionOrder.product.forging_measure_3 ? this.$formatter.replaceDotWithComma(productionOrder.product.forging_measure_3) : ''}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.order_measures')}:</label>
                  </div>
                  <div class="col-xs-8">
                    ${productionOrder.product.order_measure_1 ? this.$formatter.replaceDotWithComma(productionOrder.product.order_measure_1) : ''} -
                     ${productionOrder.product.order_measure_2 ? this.$formatter.replaceDotWithComma(productionOrder.product.order_measure_2) : ''}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.plan_weight')}:</label>
                  </div>
                  <div class="col-xs-8">
                    ${productionOrder.product.plan_weight ? this.$formatter.replaceDotWithComma(productionOrder.product.plan_weight) : ''}
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.forging_weight')}:</label>
                  </div>
                  <div class="col-xs-8">
                    ${productionOrder.product.forging_weight ? this.$formatter.replaceDotWithComma(productionOrder.product.forging_weight) : ''}
                  </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.weightForPresse')}:</label>
                  </div>
                  <div class="col-xs-8">
                    <hr class="mt-6"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.qtyStampedOut')}:</label>
                  </div>
                  <div class="col-xs-8">
                    <hr class="mt-6"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.finalWeight')}:</label>
                  </div>
                  <div class="col-xs-8">
                    <hr class="mt-6"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.restVolume')}:</label>
                  </div>
                  <div class="col-xs-8">
                    <hr class="mt-6"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-xs-4">
                    <label>${this.$t('message.productionOrder.weightPerPiece')}:</label>
                  </div>
                  <div class="col-xs-8">
                    <hr class="mt-6"/>
                  </div>
                </div>
              </div>
            </div>
          </div>`
    },
    constructRawMaterial (materials) {
      // RAW Materials
      let rawMeterals = ''
      if (materials) {
        for (let i = 0; i < materials.length; i++) {
          rawMeterals += `<tr>
            <td>${materials[i].rawmaterial_number || ''} - ${materials[i].rawmaterial_name || ''}</td>
            <td>${this.$store.state.locale === 'no' ? (materials[i].no_unit ? materials[i].no_unit : '') : (materials[i].en_unit ? materials[i].en_unit : '')}</td>
            <td class="text-right">${materials[i].in_production ? this.$_thousandSeparator(this.$formatter.replaceDotWithComma(materials[i].in_production)) : ''}</td>
            <td class="text-right">${materials[i].produced ? this.$_thousandSeparator(this.$formatter.replaceDotWithComma(materials[i].produced)) : ''}</td>
            <td></td>
            <td class="text-right">${materials[i].rest ? this.$_thousandSeparator(this.$formatter.replaceDotWithComma(materials[i].rest)) : ''}</td>
            <td></td>
          </tr>`
        }
        return rawMeterals
      } else return ''
    },
    downloadReport () {
      const reportName = `report_${this.reportData.order.number}.pdf`
      const getBase64Content = { content: this.generateReportForOrder(), filename: reportName }
      this.$_executeApi('post', '/productionorders/generate_pdf', getBase64Content)
        .then((response) => {
          if (response.data) {
            this.$_downloadExportedReport(response.data)
            this.$eventBus.$emit('hideDownloadReporteLoading', this.moduleName)
          }
        })
    }
  },
  beforeDestroy () {
    this.$root.$off('getDataForPDF')
  }
}
// this.getBarCodeForProduct(productionOrder.product.product_number)
</script>
